"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createResponse = createResponse;
exports.createErrorResponse = createErrorResponse;
exports.removeMetadataFields = removeMetadataFields;
exports.addMetadataFields = addMetadataFields;
exports.removeHtmlTags = removeHtmlTags;
exports.handleErrorResponse = handleErrorResponse;
exports.removeLookUpDataFields = removeLookUpDataFields;
const common_1 = require("@nestjs/common");
const enum_1 = require("../enum");
function createResponse(status, message, data) {
    return { status, message, data };
}
function createErrorResponse(status, message, data) {
    return { status, message, data };
}
function removeMetadataFields(data) {
    if (Array.isArray(data)) {
        // If data is an array, apply function recursively to each element
        data.forEach((item) => removeMetadataFields(item));
    }
    else if (data && typeof data === "object") {
        // Delete metadata fields
        const metadataFields = [
            "createdAt",
            "updatedAt",
            "deletedAt",
            "createdBy",
            "updatedBy",
        ];
        metadataFields.forEach((field) => delete data[field]);
        // Recursively process each object property
        Object.keys(data).forEach((key) => {
            if (typeof data[key] === "object" && data[key] !== null) {
                removeMetadataFields(data[key]);
            }
        });
    }
}
function addMetadataFields(data, metadata) {
    if (Array.isArray(data)) {
        // If data is an array, apply function recursively to each element
        data.forEach((item) => addMetadataFields(item, metadata));
    }
    else if (data && typeof data === "object") {
        // Add metadata fields
        Object.assign(data, metadata);
        // Recursively process each object property
        Object.keys(data).forEach((key) => {
            if (typeof data[key] === "object" && data[key] !== null) {
                addMetadataFields(data[key], metadata);
            }
        });
    }
}
/**
 * Removes HTML tags from a given string.
 * @param html - The HTML string to process.
 */
function removeHtmlTags(html) {
    if (!html)
        return "";
    return html.replace(/<\/?[^>]+(>|$)/g, "").trim();
}
function handleErrorResponse(error, res, notFoundMessage = "Resource not found", forbiddenMessage = "Forbidden", badRequestMessage = "Bad request") {
    if (error instanceof common_1.NotFoundException) {
        return res
            .status(enum_1.statusCode.notFound)
            .json(createErrorResponse(enum_1.statusCode.notFound, error.message ? error.message : notFoundMessage));
    }
    else if (error instanceof common_1.ForbiddenException) {
        return res
            .status(enum_1.statusCode.forbidden)
            .json(createErrorResponse(enum_1.statusCode.forbidden, error.message ? error.message : forbiddenMessage));
    }
    else {
        return res
            .status(enum_1.statusCode.badRequest)
            .json(createErrorResponse(enum_1.statusCode.badRequest, error.message ? error.message : badRequestMessage));
    }
}
function removeLookUpDataFields(data) {
    if (Array.isArray(data)) {
        // If data is an array, apply function recursively to each element
        data.forEach((item) => removeLookUpDataFields(item));
    }
    else if (data && typeof data === "object") {
        // Delete lookup metadata fields
        const metadataFields = [
            "lookUpKey",
            "lookUpName",
            "lookUpValueKey",
            "createdBy",
            "description",
            "lookUpOrder",
        ];
        metadataFields.forEach((field) => delete data[field]);
        // Recursively process each object property
        Object.keys(data).forEach((key) => {
            if (typeof data[key] === "object" && data[key] !== null) {
                removeLookUpDataFields(data[key]);
            }
        });
    }
}
